import React from "react";
import { createRoot } from "react-dom/client";
import { installThemeVars } from "./theme";
import { App } from "./App";
import "./styles.css";

installThemeVars();

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
